import { FC } from 'react';

import { useBodyScrollLock } from '@/hooks/useBodyScrollLock';

import * as S from './Overlay.styles';

interface OverlayProps {
  onClick?: () => void;
  top?: number;
  zIndex?: number;
}

export const Overlay: FC<OverlayProps> = ({
  onClick,
  top,
  zIndex,
  ...rest
}) => {
  useBodyScrollLock(true);

  return <S.Overlay $zIndex={zIndex} $top={top} onClick={onClick} {...rest} />;
};
